import axios from 'axios';

const instance = axios.create();

instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response;
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default {
  /**
   * GET 方法
   * @param {string} url
   * @param {axios.AxiosRequestConfig<any>} [config]
   * @returns {Promise<any>}
   */
  async get(url, config = {}) {
    const res = await instance.get(url, config);
    return res.data;
  },

  /**
   * POST 方法
   * @param {string} url
   * @param {any} [data]
   * @param {axios.AxiosRequestConfig<any>} [config]
   * @returns {Promise<any>}
   */
  async post(url, data = {}, config = {}) {
    const res = await instance.post(url, data, config);
    return res.data;
  },

  instance,
};
